import { NodeType } from '@amplify/amp-module';
import InsightsNodeHandler from '../insights-node-handler';

export default class GoToHandler extends InsightsNodeHandler {
  constructor(ctx) {
    super(ctx, NodeType.goTo);
  }

  async handleNode(node) {
    await super.handleNode(node, { addToStack: false, handleStorage: false });
    const conversation = this.store.getters['chatbotStore/getConversation'](node.conversationId);
    const currentAmp = this.store.getters['chatbotStore/currentAmp'];
    const isPreview = this.store.getters['chatbotStore/isPreview'];
    const isEdetailer = currentAmp.ampType === 'edetailer';

    if (!conversation && !node.webLink) {
      this.store.dispatch('chatbotStore/endConversation');
      return undefined;
    }

    if (node.webLink) {
      this.store.dispatch('chatbotStore/endConversation');

      if (!isPreview) {
        if (isEdetailer || window.location.host.replace(/^www\./, '') !== new URL(node.webLink).host) {
          window.open(node.webLink);
        } else {
          window.location.assign(node.webLink);
        }
      }

      return undefined;
    }

    const prevConversationId = this.store.getters['chatbotStore/currentConversationId'];

    if (isEdetailer && !isPreview) {
      this.store.dispatch('chatbotStore/setIframeUrl', conversation.id);
    }

    this.store.dispatch('chatbotStore/setupConversation', conversation);

    this.trackResponseEvent('conversationChange', {
      prevConversationId,
      changeEvent: 'GO_TO',
    });

    const currentSlide = this.store.getters['chatbotStore/getSlide'](prevConversationId);
    const nextSlide = this.store.getters['chatbotStore/getSlide'](conversation.id);

    // slides are not available in preview mode and
    // we don't need to wait for the slide to load when the new conversation has the same slide
    if (isEdetailer && !isPreview && currentSlide !== nextSlide) {
      const result = new Promise((resolve) => {
        this.unwatch = this.store.watch(
          (state) => state.chatbotStore.isSlideLoading,
          (newValue) => {
            if (!newValue) {
              this.unwatch();

              resolve(this.store.getters['chatbotStore/nextNode']());
            }
          }
        );
      });

      return result;
    }

    return this.store.getters['chatbotStore/nextNode']();
  }
}
